// Color palette extracted from the new design system

export const colors = {
  // Primary colors
  primary: {
    main: '#2c5aa0',
    dark: '#1e3a5f',
    light: '#4a7bc8'
  },

  // Status colors
  success: {
    main: '#27ae60',
    light: 'rgba(46, 204, 113, 0.2)',
    border: 'rgba(46, 204, 113, 0.3)'
  },

  error: {
    main: '#e74c3c',
    light: 'rgba(231, 76, 60, 0.2)',
    border: 'rgba(231, 76, 60, 0.3)'
  },

  warning: {
    main: '#f5a623',
    light: 'rgba(245, 166, 35, 0.2)',
    border: 'rgba(245, 166, 35, 0.3)'
  },

  info: {
    main: '#3498db',
    light: 'rgba(52, 152, 219, 0.2)',
    border: 'rgba(52, 152, 219, 0.3)'
  },

  // Neutral colors
  neutral: {
    100: '#f8f9fa',
    200: '#e9ecef',
    300: '#dee2e6',
    400: '#ced4da',
    500: '#95a5a6',
    600: '#7f8c8d',
    700: '#5d6d7e',
    800: '#2c3e50',
    900: '#1a252f'
  },

  // Glass morphism colors
  glass: {
    white: 'rgba(255, 255, 255, 0.25)',
    whiteStrong: 'rgba(255, 255, 255, 0.3)',
    whiteLight: 'rgba(255, 255, 255, 0.1)',
    border: 'rgba(255, 255, 255, 0.2)',
    borderStrong: 'rgba(255, 255, 255, 0.3)'
  },

  // Site group pill colors
  siteGroup: {
    background: 'linear-gradient(135deg, rgba(74, 144, 226, 0.15) 0%, rgba(155, 89, 182, 0.15) 100%)',
    backgroundHover: 'linear-gradient(135deg, rgba(74, 144, 226, 0.25) 0%, rgba(155, 89, 182, 0.25) 100%)',
    color: '#4a90e2',
    border: 'rgba(74, 144, 226, 0.2)',
    borderHover: 'rgba(74, 144, 226, 0.3)'
  }
};
